import { useRef } from 'react';
import { SECONDARY_MENU_ID } from 'palette/HeaderDropdown/constants/menuIds';
import { useIntendedHover } from 'palette/hooks/useIntendedHover';
import { Icon } from 'palette/Icon';
import { BodyText } from 'palette/Typography';
import { useConfig } from '@common/Hooks/useConfig';
import { useTranslate } from '@common/Translations';
import { BEMBlock } from '@helpers/classnames';
import { hasSecondaryLevelMenuItemDropdown } from '@helpers/navigation';
import { getTranslatedPropertyFromContext } from '@helpers/translationContext';

const getHref = (urlPrefix, navItem, config) => `${urlPrefix}${getTranslatedPropertyFromContext(navItem, 'url', config)}`;

export function NavigationItem({
    activeDropdownItem,
    hasMainHeaderDropdown,
    navItem,
    navTree,
    index,
    isActive,
    onClick,
    onHover,
    onFocus
}) {
    const config = useConfig();
    const translate = useTranslate();
    const { intentRef } = useIntendedHover(() => onHover(navItem, index));
    const ref = useRef(null);
    const [, BEMElement] = BEMBlock('header-navigation');
    const { URLPrefix } = config;
    const {
        cssClass, idNameSlug, url, uuid
    } = navItem;
    const label = getTranslatedPropertyFromContext(navItem, 'name', config);

    const handleFocus = () => {
        onFocus(navItem);
    };

    const handleClick = (event) => {
        onClick(event, navTree, navItem);
    };

    const MenuItem = url ? 'a' : 'div';

    return (
        <div
            key={uuid}
            ref={intentRef}
            className={`${BEMElement('category-item')}`}
            data-cs-id={idNameSlug}
        >
            <MenuItem
                {...url && {
                    href: getHref(URLPrefix, navItem, config)
                }}
                ref={ref}
                className={BEMElement('category-link', { default: !url })}
                tabIndex={0}
                onClick={handleClick}
                onMouseOver={handleFocus}
            >

                <BodyText
                    className={cssClass}
                    level="2"
                    weight={isActive ? 'bold' : 'regular'}
                >
                    {label}
                </BodyText>
            </MenuItem>
            {hasSecondaryLevelMenuItemDropdown(navItem, hasMainHeaderDropdown) && (
                <button
                    aria-controls={SECONDARY_MENU_ID}
                    aria-expanded={activeDropdownItem === navItem}
                    aria-haspopup="dialog"
                    aria-label={[label, translate('header.menu.label')].join(' ')}
                    className={BEMElement('dropdown-trigger')}
                    onClick={handleFocus}
                >
                    <Icon
                        name="palette_chevron_down"
                        size="x-small"
                    />
                </button>
            )}
        </div>
    );
}

export default null;
